import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { AdminService } from "../../services/admin.service";
import { onFetchInstructorCourse } from "../../store/actions/InstructorCourse";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import Select from "react-select";
import toast from "react-hot-toast";
import moment from "moment";
import SideModal from "../SideModal/SideModal";
import CalenderInput from "./DatePicker";
import { ICreateDemoSession } from "../../interfaces/createDemoSession";
import { countries } from "../../utilis/country.utiils";

interface ICreateDemoSessionBySlotLinkProps {
    show: boolean;
    setShow: any;
    instructor?: any;
    demoTime?: { startTime: Date, endTime: Date };
    demoInfo?: {
        date: Date;
        slot: {
            startTime: string;
            endTime: string;
        };
    }
}

export default function CreateDemoSessionBySlotModal(
    props: ICreateDemoSessionBySlotLinkProps
) {
    const [finalSaveState, setFinalSaveState] = useState<any>({
        coordinator: "",
        dhunguruDiscount: 0,
        totalSession: 0,
        councellor: "",
    });

    const dispatch = useAppDispatch();
    const [inputStudentValue, setInputStudentValue] = useState<any>();
    const [inputCourseValue, setInputCourseValue] = useState<any>();
    const [date, setDate] = useState(moment(props.demoTime?.startTime).isValid() ? moment(props.demoTime?.startTime).toDate() : moment().add("1", "hours").startOf("hour").toDate());
    const [demoTime, setDemoTime] = useState(moment(props.demoTime?.startTime).isValid() ? moment(props.demoTime?.startTime).toDate() : moment().add("1", "hours").startOf("hour").toDate());
    const [instructorCourses, setInstructorCourses] = useState<any>();
    const [courses, setCourses] = useState<any[]>([]);
    const [selOption, setSelOption] = useState<any>(props.instructor);
    const [loading, setLoading] = useState<boolean>(false);
    const [coordinators, setCoordinators] = useState<any>();
    const [councellor, setCouncellor] = useState<any>();

    const handelInstructorChanges = (obj: any) => {
        setSelOption(obj);
    };

    const id = selOption?.value || "";

    useEffect(() => {
        if (!id) return;
        dispatch(onFetchInstructorCourse({ id }));
    }, [id, dispatch]);

    const fetchInstructorData = (inputValue: any, callback: ([]) => void) => {
        if (!inputValue) {
            callback([]);
        } else {
            setTimeout(() => {
                AdminService.getAllInstructor(inputValue).then((res) => {
                    if (res.status === 200) {
                        const instructors = res.data.data.map((data: any) => {
                            return {
                                value: data._id,
                                label: `${data.firstName}  ${data.lastName} - ${data.email}`,
                            };
                        });
                        callback(instructors);
                    }
                });
            }, 1000);
        }
    };


    useEffect(() => {
        setDate(moment(props.demoTime?.startTime).isValid() ? moment(props.demoTime?.startTime).toDate() : moment().add("1", "hours").startOf("hour").toDate());
        setDemoTime(moment(props.demoTime?.startTime).isValid() ? moment(props.demoTime?.startTime).toDate() : moment().add("1", "hours").startOf("hour").toDate());
        setSelOption(props.instructor);
    }, [props.show])


    const fetchCoordinators = () => {
        AdminService.getAllCoordinators().then((res) => {
            if (res.status === 200) {
                const valid_coor = res.data.filter((data: any) => data.adminVisibility.includes("COORDINATOR"));
                const valid_cons = res.data.filter((data: any) => data.adminVisibility.includes("COUNSELLOR"));

                setCoordinators(
                    valid_coor.map((data: any) => {
                        return {
                            value: data._id,
                            label: `${data.firstName} ${data.lastName}`,
                        };
                    })
                );
                setCouncellor(
                    valid_cons.map((data: any) => {
                        return {
                            value: data._id,
                            label: `${data.firstName} ${data.lastName}`,
                        };
                    })
                );
            }
        });
    };

    const fetchCourseData = () => {
        if (!id) return;
        AdminService.getInstructorCourses({ id }).then((res) => {
            if (res.status === 200) {
                setInstructorCourses(
                    res?.data?.data?.map((data: any) => {
                        return {
                            value: data._id,
                            label: `${data.title}`,
                        };
                    })
                );
            }
        });
    };

    useEffect(() => {
        fetchCourseData();
        fetchCoordinators();
    }, [id]);

    const getInsructorCourses = async (id: string) => {
        setCourses([]);
        if (!id) return;
        await AdminService.getInstructorCourses({ id }).then((res) => {
            if (res.status === 200) {
                setCourses(
                    res.data.data.finalData.courses.map((course: any) => {
                        return {
                            value: course._id,
                            label: (
                                <span className="fs-12 fw-bold text-secondary">
                                    {" "}
                                    {course.instrument}
                                </span>
                            ),
                        };
                    })
                );
            }
        });
    };

    useEffect(() => {
        if (selOption && selOption.value) {
            getInsructorCourses(selOption.value);
        }
    }, [selOption]);

    const fetchStudentData = (inputValue: any, callback: ([]) => void) => {
        if (!inputValue) {
            callback([]);
        } else {
            setTimeout(() => {
                AdminService.getAllStudents(inputValue).then((res) => {
                    if (res.status === 200) {
                        const students = res.data.data.map((data: any) => {
                            return {
                                value: data._id,
                                label: `${data.firstName} ${data.lastName} - ${data.email}`,
                            };
                        });
                        callback(students);
                    }
                });
            }, 1000);
        }
    };

    const handleChange = (e: any) => {
        setFinalSaveState({ ...finalSaveState, [e.target.name]: e.target.value });
    };


    const markSlotAsBooked = async () => {
        if (!props.demoInfo) return;
        const payload = {
            date: props.demoInfo.date,
            slot: {
                startTime: props.demoInfo.slot.startTime,
                endTime: props.demoInfo.slot.endTime
            }
        }
        await AdminService.markDemoSlotAsBooked(props.instructor.value, payload).then((res) => {
            if (res.status == 200) {
                toast.success("Session marked as Booked");
            }
        })
            .catch((err) => {
                toast.error("Session Link Created, but there was a problem while marking session as Booked");
                console.error("Error marking slot as booked:", err);
            });
    }

    const onSubmit = async () => {
        setLoading(true);

        const inputData: ICreateDemoSession = {
            instructorId: selOption?.value || " ",
            studentId: inputStudentValue?.value || " ",
            courseId: inputCourseValue?.value || " ",
            coordinator: finalSaveState?.coordinator || " ",
            session_date_time: date,
            councellor: finalSaveState?.councellor || " ",
            country: finalSaveState?.country || " ",
            actual_demo_time: demoTime
        };

        if (!inputData.councellor || !inputData.coordinator) {
            toast.error("Coordinator and Councellor are Mandatory")
            setLoading(false);
            return false
        }

        toast.promise(AdminService.createDemoSession(inputData)
            .then((res: any) => {
                if (res.status === 200) {
                    props.setShow(false);
                    setFinalSaveState({
                        coordinator: "",
                        councellor: ""
                    });
                    setSelOption({})
                    setInputCourseValue({})
                    setInputStudentValue({})
                    setDate(moment().add("1", "hours").startOf("hour").toDate())
                    toast.success("Success: Link Created!");
                    setLoading(false);
                }
            })
            .then(async (e) => {
                await markSlotAsBooked();
                setLoading(false);
                console.error(e);
            }), {
            loading: 'Creating Link',
            success: 'Link Created',
            error: 'Link Creation Failed',
        })

    }

    return (
        <SideModal
            show={props.show}
            handleClose={() => props.setShow(false)}
            title="Create Demo Enrollment"
            body={
                <>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold fs-12 text-secondary">Selected Guru</Form.Label>
                        <Select
                            name="instructor"
                            options={selOption}
                            isSearchable={false}
                            onChange={handelInstructorChanges}
                            value={selOption}
                        />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold fs-12 text-secondary">Select the Student</Form.Label>

                        <AsyncSelect
                            name="studentId"
                            loadOptions={fetchStudentData}
                            onChange={setInputStudentValue}
                            isClearable={true}
                            value={inputStudentValue}

                        />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold fs-12 text-secondary">Select the Course</Form.Label>
                        <Select
                            name="courseId"
                            options={instructorCourses}
                            onChange={setInputCourseValue}
                            value={inputCourseValue}
                        />
                        <Form.Group className="mt-2">
                            <Form.Label className="fw-bold fs-12 text-secondary">Enrollment Type</Form.Label>
                            <Form.Control
                                type="text"
                                name="enrollmentType"
                                disabled={true}
                                value="Demo"
                            />
                        </Form.Group>
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold fs-12 text-secondary">Date</Form.Label>
                        <CalenderInput
                            setValue={(date: any) => {
                                setDate(date);
                            }}
                            selected={date}
                        />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Coordinator
                        </Form.Label>
                        <Select
                            name="coordinatorId"
                            options={coordinators}
                            isClearable={true}
                            onChange={(e: any) => {
                                const event = {
                                    target: {
                                        name: "coordinator",
                                        value: e?.label,
                                    },
                                }
                                handleChange(event);
                            }}
                            value={coordinators?.find((data: any) => data.label === finalSaveState.coordinator)}
                        />
                    </Form.Group>

                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Councellor
                        </Form.Label>
                        <Select
                            name="councellorId"
                            options={councellor}
                            isClearable={true}
                            onChange={(e: any) => {
                                const event = {
                                    target: {
                                        name: "councellor",
                                        value: e?.label,
                                    },
                                }
                                handleChange(event);
                            }}
                            value={councellor?.find((data: any) => data.label === finalSaveState.councellor)}
                        />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Country
                        </Form.Label>
                        <Select
                            options={countries.map((country) => {
                                return {
                                    label: country,
                                    value: country,
                                };
                            })}
                            // value={country}
                            onChange={(e: any) => {
                                const event = {
                                    target: {
                                        name: "country",
                                        value: e?.value,
                                    },
                                }
                                handleChange(event);
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mt-2">
                        <Form.Label className="fw-bold fs-12 text-secondary">Actual Demo Time</Form.Label>
                        <CalenderInput
                            setValue={(date: any) => {
                                setDemoTime(date);
                            }}
                            selected={demoTime}
                            interval={30}
                        />
                    </Form.Group>
                    <Button className="mt-4" onClick={onSubmit} size="sm" disabled={loading}>
                        Book Session
                    </Button>
                </>
            }
        />
    );
}
